import { render, staticRenderFns } from "./Continents.vue?vue&type=template&id=91a08122&scoped=true&"
import script from "./Continents.vue?vue&type=script&lang=js&"
export * from "./Continents.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91a08122",
  null
  
)

export default component.exports